module.exports = __webpack_public_path__ + "competition.58c9e032.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/competition.png
// module id = 901
// module chunks = 0